<template>
  <div class="base_main bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('PersonnelManagement') }} > {{ $t('activePosition') }}</div>
    <div class="common-table-cnt">
      <div class="search search-container">
        <el-form :inline="true" :model="formData" class="demo-form-inline">
          <!-- 机构列表 -->
          <el-form-item :label="$t('mechanism')">
            <el-select
              ref="paramOuSelect"
              v-model="formData.ouName"
              style="width:auto"
              :placeholder="$t('peaseSelect')"
              :popper-append-to-body="false"
              @change="changeParamOu"
              clearable
              @visible-change="visibleChange"
            >
              <el-option :value="formData.ouName" style="height:auto;padding:0px">
                <el-tree
                  ref="paramOuTree"
                  node-key="id"
                  default-expand-all
                  highlight-current
                  :expand-on-click-node="false"
                  :data="ouList"
                  :props="defaultProps"
                  @node-click="selectParamOu"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          
          <!-- 记录时间 -->
          <el-form-item :label="$t('statisticalPeriod')" class="datetime">
            <el-date-picker
              v-model="formData.startStatisticsTime"
              :placeholder="$t('startDate')"
              type="date"
              value-format="yyyy-MM-dd"
              popper-class="date-picker-blue-hw"
              :clearable="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('TO')">
            <el-date-picker
              v-model="formData.endStatisticsTime"
              :placeholder="$t('endDate')"
              type="date"
              value-format="yyyy-MM-dd"
              popper-class="date-picker-blue-hw"
              :clearable="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('rcordingDuration')" class="datetime">
            <el-input
              clearable
              :placeholder="$t('minimumHour')"
              type="number"
              v-model="formData.minVideoDuration"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('TO')" class="totime">
            <el-input
              clearable
              :placeholder="$t('maximumHour')"
              type="number"
              v-model="formData.maxVideoDuration"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('intercomFrequency')" class="datetime">
            <el-input
              clearable
              :placeholder="$t('minimumValue')"
              type="number"
              v-model="formData.minIntercomNumber"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('TO')" class="totime">
            <el-input
              clearable
              :placeholder="$t('maximumValue')"
              type="number"
              v-model="formData.maxIntercomNumber"
            ></el-input>
          </el-form-item>
          <!-- 用户名 -->
          <el-form-item :label="$t('userNameH')">
            <el-input v-model="formData.userName" clearable :placeholder="$t('userNameH')"></el-input>
          </el-form-item>
          <!-- 按钮 -->
          <el-form-item>
            <el-button type="primary" @click="getList" class="serachBtn">{{ $t('query') }}</el-button>
            <el-button type="primary" @click="exportList" :loading="exportLoading" class="serachBtn">{{ $t('exportButton') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- table开始 -->
      <div class="table-box">
        <Table
          :tableHeight="648"
          :data="tableData"
          :columns="columns"
          :operation="dateOperation"
          :showSelcet="false"
          @getList="getList"
          :currentPage="currentPage"
          :pageSize="pageSize"
          ref="tanleAssembly"
          @sortChange="handleSort"
        ></Table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { statisticsPage } from '@/api/new-person/newPerson'
import { getOus } from '@/api/UserList'
import { nowDate, beforeMonthDate } from '@/util/date'
import { getExportStatistics } from '@/api/log/log'
import { downloadBlobExcel } from '@/util/common'
// 引入table组件
import Table from '@/components/NewTable'
export default {
  data() {
    return {
      // 查询表单
      formData: {
        userName: '',
        ouId: null,
        ouName: '',
        startStatisticsTime: beforeMonthDate(),
        endStatisticsTime: nowDate(),
      },
      columns: [],
      dateOperation: [],
      // table 数据
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      // 机构列表
      ouList: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      exportLoading: false,
    }
  },
  components: {
    Table,
  },
  methods: {
    //导出列表
    exportList() {
      if(this.totalData >= 100000) {
        this.$message({
          type: 'warning',
          message: this.$t('maxFile'),//提示用户数据量过大，无法导出
        })
        return
      }
      this.exportLoading = true
      let params = {
        userName: this.formData.userName.trim(),
        ouId: this.formData.ouId,
        startStatisticsTime: this.formData.startStatisticsTime,
        endStatisticsTime: this.formData.endStatisticsTime,
        minVideoDuration: this.formData.minVideoDuration ? this.formData.minVideoDuration * 60 : null,
        maxVideoDuration: this.formData.maxVideoDuration ? this.formData.maxVideoDuration * 60 : null,
        minIntercomNumber: this.formData.minIntercomNumber,
        maxIntercomNumber: this.formData.maxIntercomNumber,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        type: 1, // 0：人员活跃统计 1：人员数据统计
        sortColName: this.formData.sortColName,
        useAsc: this.formData.useAsc
      }
      getExportStatistics(params).then(res => {
        this.exportLoading = false
        downloadBlobExcel(res, this.$t('activePosition') + '.xls')
      })
    },
    // 排序
    handleSort(data) {
      this.formData.sortColName = !data.order ? null : data.column.sortable
      this.formData.useAsc = data.order=== "descending" ? 0 : 1
      this.getList()
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.ouList = res.data
        }
      })
    },
    // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      this.formData.ouName = data.name
      this.formData.ouId = data.id
      this.$refs.paramOuSelect.blur()
    },
    // 清空过滤条件机构，过滤用户
    changeParamOu(data) {
      if (!data) {
        this.formData.ouId = null
        this.formData.ouName = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },
    // 查询列表
    getList() {
      this.currentPage = 1
      this.search()
    },
    // 获取table数据
    search() {
      let params = {
        userName: this.formData.userName.trim(),
        ouId: this.formData.ouId,
        startStatisticsTime: this.formData.startStatisticsTime,
        endStatisticsTime: this.formData.endStatisticsTime,
        minVideoDuration: this.formData.minVideoDuration ? this.formData.minVideoDuration * 60 : null,
        maxVideoDuration: this.formData.maxVideoDuration ? this.formData.maxVideoDuration * 60 : null,
        minIntercomNumber: this.formData.minIntercomNumber,
        maxIntercomNumber: this.formData.maxIntercomNumber,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        type: 1, // 0：人员活跃统计 1：人员数据统计
        sortColName: this.formData.sortColName,
        useAsc: this.formData.useAsc
      }
      statisticsPage(params).then(res => {
        if (res.state === 0) {
          if (res.value.list) {
            this.tableData = res.value.list.map(item => {
              item.allRealVideo = item.realVideoDuration ? (item.realVideoDuration / 60).toFixed(2) : 0 //总、分钟化小时
              item.allMonitor = item.monitorDuration ? (item.monitorDuration / 60).toFixed(2) : 0 //日、分钟化小时
              item.allVideoDuration = item.videoDuration ? (item.videoDuration / 60).toFixed(2) : 0 //总、次数
              item.intercomNumber = item.intercomNumber ? item.intercomNumber : 0 //总、次数
              item.staticTime =
                item.startStatisticsTime && item.endStatisticsTime
                  ? item.startStatisticsTime.split(' ')[0] + ' - ' + item.endStatisticsTime.split(' ')[0]
                  : '' //统计时间
              return item
            })
          } else {
            this.tableData = []
          }
          this.totalData = res.value.total
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.search()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.search()
    },
    baseConfig() {
      // table 表头配置数据
      this.columns = [
        {
          attrName: 'userName',
          label: this.$t('userNameH'),
          allowHande: 'dataCenter',
          sort: 'userName',
        },
        {
          attrName: 'ouName',
          label: this.$t('mechanism'),
          sort: 'ouName',
        },
        {
          attrName: 'staticTime',
          label: this.$t('statisticalPeriod'),
          align: 'center',
          sort: 'staticTime',
        },
        {
          attrName: 'videoNumber',
          label: this.$t('numberVideos'),
          align: 'right',
          width: '144',
          sort: 'videoNumber',
        },
        {
          attrName: 'photoNumber',
          label: this.$t('numberPictures'),
          align: 'right',
          width: '160',
          sort: 'photoNumber',
        },
        {
          attrName: 'trajectoryNumber',
          label: this.$t('numberTracks'),
          align: 'right',
          width: '140',
          sort: 'trajectoryNumber',
        },
        {
          attrName: 'intercomNumber',
          label: this.$t('intercomFrequency'),
          align: 'right',
          width: '176',
          sort: 'intercomNumber',
        },
        {
          attrName: 'allVideoDuration',
          label: this.$t('recordingDuration'),
          align: 'right',
          width: '150',
          sort: 'videoDuration',
        },
        {
          attrName: 'allMonitor',
          label: this.$t('monitoringDuration'),
          align: 'right',
          width: '160',
          sort: 'monitorDuration',
        },
        {
          attrName: 'allRealVideo',
          label: this.$t('realTimeVideoDuration'),
          align: 'right',
          width: '190',
          sort: 'realVideoDuration',
        },
      ]
    },
  },

  mounted() {
    this.baseConfig()
    this.getOusTree()
    this.search()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl';
@import '~@/style/new-set-common.styl'
.base_main
  .common-table-cnt
    .search
      >>>.el-date-editor
        width: 140px!important;/*no*/
      .datetime,.totime
        >>>.el-input
          width 140px!important;/*no*/
    .el-button
      margin-left 10px
    .timeInterval
      display flex
      justify-content space-between
      flex-wrap wrap
    .pagination
      float right
      margin-top 10px
>>>.el-popper
  min-width 200px!important;/*no*/
>>>.el-tree-node__content
  color: var(--new-el-select-dropdown-item);
</style>
